import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteProductSet } from "./deleteProductSet.request";

const useDeleteProductSet = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchProductSets = useRefetchQuery(["product-sets", "all"]);

  return useMutation({
    mutationFn: requestDeleteProductSet,
    ...options,
    onSuccess: (...args) => {
      refetchProductSets();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteProductSet;
